/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createMissingInstrumentLinkInFranklin} from '../api'

export const useMutationCreateMissingInstrumentLinkInFranklin = createReactQueryMutationHook('createMissingInstrumentLinkInFranklin', createMissingInstrumentLinkInFranklin)
